import { useDataSource } from '@/src/renderer/lib/dataSource'
import type { Habit, LifeSpace } from '@/src/renderer/lib/db/models'

/**
 * Reactive list of habits for a life space, by sortOrder.
 *
 * Returns `undefined` while the first read is pending so callers can render a
 * loading state. Includes paused habits — the view decides whether to show
 * them (the "Pausierte anzeigen" toggle). Soft-deleted habits are excluded.
 */
export function useHabits(lifeSpace: LifeSpace): Habit[] | undefined {
  return useDataSource().useHabits(lifeSpace)
}
